import ContentPage from "./ContentPage";

export default function Cookies() {
  return (
    <ContentPage title="Cookie policy" eyebrow="Legal">
      <p className="lead">
        We use cookies and similar technologies to run the shop, remember preferences, and understand usage patterns.
      </p>
      <p>
        You can control cookies through your browser settings. Strictly necessary cookies may be required for checkout and account security.
      </p>
    </ContentPage>
  );
}
